const baseUrlOptions = {
    SOUTH_AFRICA : "ZA",
    UNITED_KINGDOM : "GB"
}

export default baseUrlOptions